import { render, staticRenderFns } from "./ChoosePayment.vue?vue&type=template&id=01697f11&scoped=true&"
import script from "./ChoosePayment.vue?vue&type=script&lang=js&"
export * from "./ChoosePayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01697f11",
  null
  
)

export default component.exports